var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgHero2 = function SvgHero2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hero_2_svg__hero",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 479.5 814.5",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_2_svg__linear-gradient",
    x1: 100.6728,
    y1: 307.1782,
    x2: 383.9886,
    y2: 568.4326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33dc8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53bcc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7026,
    stopColor: "#67aed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#809be5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient",
    cx: 226.3335,
    cy: 529.3289,
    r: 257.7297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad5ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8b8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-2",
    cx: 153.8334,
    cy: 385.2977,
    r: 255.0836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad5a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e89a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-3",
    cx: 192.8642,
    cy: -33.0583,
    r: 230.4185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffff40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4925,
    stopColor: "#99f76c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8381,
    stopColor: "#57f188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3eef93"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-4",
    cx: 274.9066,
    cy: 6.0824,
    r: 83.0279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#64f968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#6af66f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fe988"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-5",
    cx: 35.1158,
    cy: 17.775,
    r: 296.3492,
    xlinkHref: "#hero_2_svg__radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-6",
    cx: 392.0495,
    cy: 248.456,
    r: 201.4978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6662,
    stopColor: "#3dd9a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56e899"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-7",
    cx: 143.6126,
    cy: 525.4066,
    r: 217.1362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad5a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e899"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-8",
    cx: 183.7035,
    cy: 548.5021,
    r: 230.9947,
    xlinkHref: "#hero_2_svg__radial-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-9",
    cx: -45.311,
    cy: 268.0303,
    r: 265.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcee21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4677,
    stopColor: "#a0f576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8301,
    stopColor: "#5ef9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45fbca"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-10",
    cx: -69.5609,
    cy: 140.8946,
    r: 304.2782,
    xlinkHref: "#hero_2_svg__radial-gradient-9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-11",
    cx: 243.1699,
    cy: 362.4559,
    r: 141.6898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b56c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e893"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-12",
    cx: 355.522,
    cy: 270.3462,
    r: 197.7039,
    xlinkHref: "#hero_2_svg__radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-13",
    cx: -7.2429,
    cy: 682.0559,
    r: 272.5343,
    xlinkHref: "#hero_2_svg__radial-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-14",
    cx: -33.9901,
    cy: 567.5495,
    r: 199.4696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe47d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fc2bf"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-15",
    cx: 308.1374,
    cy: 159.5769,
    r: 94.6049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00bdaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad8a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e899"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-16",
    cx: 447.9062,
    cy: 309.3346,
    r: 261.2796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad5b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8b2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-17",
    cx: 301.4625,
    cy: 362.0482,
    r: 171.8521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2356,
    stopColor: "#4ec2c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4744,
    stopColor: "#53b6cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7146,
    stopColor: "#5aa1df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#6485f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#667fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-18",
    cx: 313.0153,
    cy: 756.2858,
    r: 489.5842,
    gradientTransform: "matrix(0.3629, -0.9318, 0.5417, 0.211, -210.2372, 888.4108)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2705,
    stopColor: "#4fc2bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5446,
    stopColor: "#57b6c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8196,
    stopColor: "#63a2cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d90d2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-19",
    cx: 326.7336,
    cy: 455.1076,
    r: 268.7126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2151,
    stopColor: "#51c3c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4332,
    stopColor: "#5db8ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6526,
    stopColor: "#72a7d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8718,
    stopColor: "#8e90ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a27fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-20",
    cx: 345.899,
    cy: 392.5495,
    r: 162.6264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3da6c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    stopColor: "#6ac0ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83cfa3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-21",
    cx: 383.3262,
    cy: 575.2978,
    r: 293.9045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2607,
    stopColor: "#24bea7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7629,
    stopColor: "#65ce99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ed493"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-22",
    cx: 420.7022,
    cy: 293.0107,
    r: 147.9075,
    gradientTransform: "translate(0.4565 -0.3878) rotate(0.0305)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#42c0a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8041,
    stopColor: "#83cb9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ccf99"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-23",
    cx: 384.7031,
    cy: 415.7366,
    r: 249.5943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009cd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4778,
    stopColor: "#60c5b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8334,
    stopColor: "#a2e0a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbeb99"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-24",
    cx: 163.578,
    cy: 172.0016,
    r: 173.2893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4002,
    stopColor: "#45cbbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8075,
    stopColor: "#86e0b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fe8b8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-25",
    cx: -29.3118,
    cy: 661.7907,
    r: 247.6438,
    xlinkHref: "#hero_2_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-26",
    cx: 284.9011,
    cy: 889.767,
    r: 195.9687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b78d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#6e7cd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5781,
    stopColor: "#7688d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#859ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8da8c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-27",
    cx: 457.4294,
    cy: 803.0336,
    r: 198.4273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7149c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1933,
    stopColor: "#724dc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3894,
    stopColor: "#7659cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5866,
    stopColor: "#7c6ed7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7848,
    stopColor: "#858ae7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9819,
    stopColor: "#91aefd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92b2ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-28",
    cx: 330.7038,
    cy: 640.254,
    r: 176.1707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6e473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3fbfc4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-29",
    cx: 268.8634,
    cy: 583.6914,
    r: 45.5138,
    xlinkHref: "#hero_2_svg__radial-gradient-28"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-30",
    cx: 165.1572,
    cy: 533.6938,
    r: 286.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76eaa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7388ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-31",
    cx: 148.7581,
    cy: 589.5922,
    r: 184.2543,
    xlinkHref: "#hero_2_svg__radial-gradient-30"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-32",
    cx: 196.0856,
    cy: 653.8335,
    r: 199.0796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2444,
    stopColor: "#4fc3c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    stopColor: "#53bbcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7415,
    stopColor: "#5baee2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9906,
    stopColor: "#669cfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#669bff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-33",
    cx: -10.5138,
    cy: 617.4264,
    r: 317.9666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dafd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    stopColor: "#51aed2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#5dadd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6687,
    stopColor: "#72aace"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8932,
    stopColor: "#8ea5cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ea3c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-34",
    cx: 246.1319,
    cy: 603.9451,
    r: 269.6183,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_2_svg__radial-gradient-22"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-35",
    cx: 148.0352,
    cy: 563.784,
    r: 199.0771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#78c6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2356,
    stopColor: "#77c2c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4744,
    stopColor: "#74b6cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7146,
    stopColor: "#6fa1df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#6885f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#667fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-36",
    cx: 61.595,
    cy: 656.7777,
    r: 85.8599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    stopColor: "#51c4be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#5dbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6687,
    stopColor: "#72b6c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8932,
    stopColor: "#8eaac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ea3c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-37",
    cx: 58.5434,
    cy: 430.2192,
    r: 345.5039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96e46f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9068,
    stopColor: "#6fbbd8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-38",
    cx: 5.8956,
    cy: 606.6099,
    r: 177.4849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96e46f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fbbd8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-39",
    cx: -24.1372,
    cy: 442.4149,
    r: 177.5713,
    xlinkHref: "#hero_2_svg__radial-gradient-24"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-40",
    cx: 170.0881,
    cy: 581.2124,
    r: 102.8368,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_2_svg__radial-gradient-22"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-41",
    cx: 361.5769,
    cy: 461.0275,
    r: 250.3397,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_2_svg__radial-gradient-22"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_2_svg__radial-gradient-42",
    cx: 257.5,
    cy: 499.6596,
    r: 262.9409,
    xlinkHref: "#hero_2_svg__radial-gradient-7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "hero_2_svg__main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hero_2_svg__bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474,551.3479q-28.8227-74.3736-57.6451-148.7473-12.7015-50.8872-25.4029-101.7744Q353.3361,186.8193,315.72,72.8123l-44.9437-29.358q-15.144-17.1255-30.2881-34.251l-42.9895,42.08L110.5428,208.8378Q101.75,234.2814,92.9562,259.725L6,389.8788q10.7473,61.1627,21.4948,122.3251l-8.7933,18.5934q8.3048,33.7617,16.61,67.5234,18.5637,37.1868,37.1273,74.3737l37.1274,75.3522,95.481,57.1567L317.3952,769.07l84.8972-94.2942.384-1.1032Q438.3382,612.51,474,551.3479Z",
    style: {
      fill: "url(#hero_2_svg__linear-gradient)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hero_2_svg__shapes_color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,390l4.5,3.5,72,97-9,93-44-66-1-3Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.5,232.5l-52,85-2,2q5.5-43.5,11-87Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,35l.5,1.5s-10.2095,48.2632-11,52l-37,45-3-2q-12.5-43-25-86L197,43,241,0Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,65l-6.5,4.5-41,16L261,88q5.5-26.5,11-53Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,132l1.5,3.5,9,49-1,47-9,6-70,21-46-50L107,205,197,43Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.5,185.5l58,22q-2.5-35.5-5-71l-22-46L261,88l-37,44Q228.25,158.75,232.5,185.5Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,390l4.5-1.5,61-14,4.5.5,3.5,6.5,3,104q-1,3-2,6Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,375l1.5-3.5,60-67,36,89q.5,5,1,10l-2,3-90,84-2,1Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5,255.5l3,1,35,47,3,6L70,375,0,390Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,205l48.5,51.5,1,4-23,47-3,2-41-54Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.5,256.5l2,5,56,54,5,2q5.75-41.75,11.5-83.5Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.5,184.5l56,18-1,4-14,23-4,4L230,234Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,533l6.5,3.5,42,38,3,3,11,14,4,7-4,2-38,2L31,602Q22.5,567.5,14,533Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,514.5l43,63L14,533Q18.25,523.75,22.5,514.5Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,65l-1.5,5.5-27,58L284,138,261,88Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,65l-34,73,4.5,64.5,6,9,100,86Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.5,275.5q.5,4,1,8l39,101L419,402q-12.25-52.25-24.5-104.5Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.5,275.5,479,554l-6.5,5.5-117,51-37-60-7-16L310,527q-1.25-67.75-2.5-135.5l59-109Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5,607.5l-2,2q-5.5,21-11,42l58,29h5L479,554Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.5,391.5l-6,8-27,82,35,52,1,1Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.5,316.5l-49,87q31,63.5,62,127l47-48,31-91-.2528-2.1082L220.5,318.5Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.5,202.5l2,10,30,95,3,6h1l44-35,3-3Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.5,313.5l-1,1q-6.5,33-13,66-.5,5.5-1,11l63-116Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.5,202.5q17.5,55.5,35,111l-7,3-91,2-7-1Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,598l2.5,1.5,24,90q1,30,2,60l-1,5Q68.75,678.25,31,602Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.5,704.5q.5,35,1,70l-1,4-114,36v-8q8.5-59.5,17-119Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-26)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,650l61.5,30.5-87,98L318,706l-.5-4.5,22-46Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,480l-46.5,48.5-1,3,1,11h1l77-7,2-1Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.5,544.5l21-3-1-13-4,2-11,9Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.5,534.5l-79,7-1,3q-6.5,41-13,82,1,29,2,58L223,690l95,16,27-56q-1.25-9.25-2.5-18.5l-24-81Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.5,541.5l-18,1-1,2q2.5,39,5,78l1,9Q226,586.5,232.5,541.5Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-31)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.5,534.5Q328.25,592.25,345,650q5.75-21.25,11.5-42.5Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-32)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5,748.5q-.5,3-1,6l99,60q8.9168-62.0932,17.8334-124.1864L216.5,689.5l-92,9Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5,403.5l3,12q20.5,62,41,124l2,3,17-14Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.5,626.5l3,64L127,700l-.5-2.5,22-58,67-16Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-35)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.5,643.5l-4,3-36,37L104,690q1.25,32.25,2.5,64.5Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5,403.5l-2,3-44,158,21,72L148,644l72.5-17.5-6-84Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-37)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,561l-6.5.5-37,31L79,598q12.5,46,25,92l44-46Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5,491.5q.5,2,1,4l47,64L125,561l43.5-157.5Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-39)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5,491.5,125,561,79,598,65.5,577.5Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-40)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5,317.5l105-4-15,78Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-41)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.5,256.5l63,61-50,86q-19-47-38-94Z",
    style: {
      fill: "url(#hero_2_svg__radial-gradient-42)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hero_2_svg__highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.5,251.5q-.2143-.6858,56-19,2-21,4-42-.5,21-1,42l27,1-28,2q-11.5083,79.0634-12,79-.49-.0683,10-79Q172.7164,252.18,172.5,251.5Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.5,316.5l72.3022-4.0118Q311.151,276.4942,300.5,240.5q12.1511,35.9941,24.3022,71.9882L350.5,292.5l-26.6978,22.9882q-8.8136,54.09-9.3022,54.0118-.4878-.075,7.3022-54.0118Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.5,560.5l29,45,42-16-41,18-12,40,9-40Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5,45.5l30,19,16,45-17-42-25,54,24-55-41,15,41-17Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.5,485.5l24,68-39,19,38-16q-27.5313,49.6952-27,50,.55.3125,31-52Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.5,423.5l-20,56-28,30,28-28q13.7111,20.1891,14,20,.29-.1911-13-21Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.5,347.5l-31,56,14,32-17-33Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.5,657.5q1,15.5,2,31l56,11-58-9Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.5,559.5l9-29q-4,15.5-8,31,5.5,20,11,40l-12-39-25,19,24-20-22-33Z",
    style: {
      fill: "#f2f2f2"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgHero2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hero_2.16c4563a2c5fa30fa4bb06bbf5b8ccc1.svg";